import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { createPopper } from "@popperjs/core";
import { useHistory } from "react-router-dom";
// import { logoutUser } from "components/CommanMethod/Commanmethod";
import BASE_URL from "components/BaseUrl/apiConfig";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import { removeLocalStorageData } from "views/auth/localStorageUtil";

const PagesDropdown = () => {
  const history = useHistory();
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };

  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  //this is the code of the logout click
  const handleLogout = () => {
    // logoutUser();
    removeLocalStorageData();
    // Redirect to the login page
    history.push("/login");
  };

  // Retrieve user data from local storage
  const storedUserData = localStorage.getItem("userData");
  let userName = "";
  let userId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    userName = userData.userName;
  }

  useEffect(() => {
    // fetch user data from the API
    fetch(`${BASE_URL}/api/Users/GetUserById?userId=${userId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setUserData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
        setLoading(false);
      });
  }, []); // Empty dependency array ensures the effect runs only once on component mount

  return (
    <>
      <BlockUiOverlay visible={loading} />
      <div
        className="lg:text-black lg:hover:text-blueGray-200 text-blueGray-900 px-3 py-3 lg:py-2 flex items-center text-xs  font-bold"
        href="#"
        ref={btnDropdownRef}
        onMouseOver={(e) => {
          e.preventDefault();
          openDropdownPopover();
        }}
        onMouseLeave={(e) => {
          e.preventDefault();
          closeDropdownPopover();
        }}
      >
        {userData && userData.image ? (
          <img
            src={userData.image}
            alt="Logo not found"
            className="shadow-xl rounded-full align-middle border-none max-w-150-px"
            style={{ width: "35px", height: "35px" }}
            title={userName}
          />
        ) : (
          <>
            <img
              src={require("assets/img/icons-user.png")}
              alt="Logo not found"
              style={{ width: "25px" }}
              title={userName}
            />
          </>
        )}

        {/* <img
          src={require("assets/img/icons-user.png")}
          alt="Logo not found"
          style={{ width: '25px' }}
          title={userName}
        /> */}

        <div
          ref={popoverDropdownRef}
          className={
            (dropdownPopoverShow ? "block " : "hidden ") +
            "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
          }
        >
          <span
            className={
              "text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400"
            }
          ></span>
          <Link
            to="/profile"
            className={
              "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            My Profile
          </Link>

          <Link
            to="/settings"
            className={
              "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            Settings
          </Link>

          <Link
            to="changepassword"
            className={
              " custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            Change Password
          </Link>

          <Link
            to="login"
            onClick={handleLogout}
            className={
              "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            Logout
          </Link>
        </div>
      </div>
    </>
  );
};

export default PagesDropdown;
